// © 2026 Orpyx Medical Technologies Inc.

import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {Teal} from "orpyx-web-common";

export const PatientActivityLogTableStyle = createStyles({
    table: {
        minWidth: 650,
    },
    loadMoreNotesButton: {
      display: "block",
      margin: '25px auto 10px',
        '& span': {
            color: 'white'
        },
    },
    // Centred (rather than top-aligned) so the action/concern pair sits centred in the row
    actionLabelCell: {
        paddingLeft: 0,
        whiteSpace: 'nowrap',
        minWidth: "200px",
        verticalAlign: 'middle',
    },
    // The body cell is nowrap so the action name and concern each stay on one line, but this
    // header is too long to hold to that - it would set a column width no row needs.
    actionLabelHeaderCell: {
        paddingLeft: 0,
        minWidth: "200px",
        whiteSpace: 'normal',
    },
    actionIconCell: {
        padding: 0,
        width: '10px',
        verticalAlign: 'middle',
        '& img': {
            width: '20px',
            height: '20px',
            margin: '0 10px 0 0',
            // Block, so the icon's line is exactly its own height and lines up with the action
            // name's line in the neighbouring cell rather than sitting on a taller inline strut.
            display: 'block',
        }
    },
    // Both action cells are centred in the row, so the icon cell needs the same two-line content
    // height as the label beside it - otherwise the icon centres on the gap between the action
    // name and the concern instead of staying level with the action name.
    actionIconSubLabelSpacer: {
        display: 'block',
        marginTop: '4px',
        fontSize: '14px',
        // Reserves the concern line's height without rendering anything in this column
        visibility: 'hidden',
    },
    actionSubLabel: {
        display: 'block',
        marginTop: '4px',
        fontSize: '14px',
        color: '#757575',
    },
    noteText: {
        wordBreak: "break-all",
        minWidth: "300px"
    },
    // The suggested action sits under the note it accompanies, but reads as its own block so the
    // nurse's note above it stays distinguishable from it.
    suggestedAction: {
        marginTop: '12px',
        paddingLeft: '10px',
        borderLeft: `3px solid ${Teal}`,
    },
    suggestedActionLabel: {
        display: 'block',
        marginBottom: '2px',
        fontSize: '11px',
        fontWeight: 'bold',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        color: '#757575',
    },
    suggestedActionText: {
        margin: 0,
        // Catalogue text, so break between words rather than mid-word like noteText above
        wordBreak: 'break-word',
    },
    // Who is expected to carry the action out, kept quieter than the action itself
    suggestedActionOwner: {
        display: 'block',
        fontSize: '13px',
        color: '#757575',
    },
    actionCol: {
        maxWidth: '150px',
        width: 'max-content',   
    },
    nowrap: {
        whiteSpace: 'nowrap',
    },
});

export const usePatientActivityLogTableStyle = makeStyles((theme: Theme) => PatientActivityLogTableStyle);